import styled from "styled-components";
import {Button} from "antd";

export const CustomButton = styled(Button)`
    margin-right: 8px;
    margin-top: 3px;
`;
